<template>
	<div class="main-table">
		<div class="main-table-box">
			<el-table
				class="grid-content"
				:data="tableData"
				border
				stripe
				:height="tableHeight"
				ref="table"
				@sort-change='sortChangeHandle'
			>
				<el-table-column
					prop="staff"
					label="员工姓名"
					align="center">
					<template slot-scope="scope">
						<el-tooltip effect="dark" :content="scope.row.staffname" placement="top-start">
							<div class="over-hidden">{{scope.row.staffname}}</div>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column
					label="客户"
					align="center"
					width="200">
					<template slot-scope="scope">
						<div>
							<div>{{scope.row.customername}}</div>
							<div>编号：{{scope.row.customercode}}</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="ordernumber"
					label="订单编号"
					align="center">
					<template slot-scope="scope">
						<div @click="goOrderDetail(scope.row)" class="under-num">{{scope.row.ordernumber}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="realpaymoney"
					label="实付金额"
					sortable="custom"
					align="center">
					<template slot-scope="scope">
						<div>{{scope.row.realpaymoney}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="commissionrules"
					label="返佣方式"
					align="center"
					width="200">
					<template slot-scope="scope">
						{{ scope.row.planway === 1 ? '按订单' : '按商品' }}：{{scope.row.commissionType === 1 ? '百分比' : '固定金额'}}（￥{{scope.row.commissionvalue}}）
					</template>
				</el-table-column>
				<el-table-column
					prop="returnmoney"
					label="返佣金额"
					sortable="custom"
					align="center">
					<template slot-scope="scope">
						<div>￥{{scope.row.returnmoney}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="ordercreatedate"
					label="下单时间"
					align="center">
				</el-table-column>
				<el-table-column
					prop="censusdate"
					label="统计时间"
					align="center">
					<template slot-scope="scope">
						<div>{{scope.row.censusdate ? scope.row.censusdate : '——'}}</div>
					</template>
				</el-table-column>
				<!-- <el-table-column label="操作" width="220" align="center">
					<template slot-scope="scope">
						<el-button type='text' size="mini" @click="getDetail(scope.row, 3)" v-if="AuthorityList['11_0001_0001_00'] || AuthorityList['11_0001_0002_00']">明细</el-button>
						<el-button type='text' size="mini" @click="deleteItem(scope.row)" v-if="AuthorityList['11_0001_0002_00']">删除</el-button>
					</template>
				</el-table-column> -->
			</el-table>
		</div>
		<!-- <el-pagination
			@size-change="handleSizeChange"
			@current-change="handlePageChange"
			:current-page="pagination.page"
			:page-sizes="[20, 40, 60, 100, 300]"
			:page-size="pagination.size"
			layout="total, sizes, prev, pager, next, jumper"
			:total="totalCount">
		</el-pagination> -->
	</div>
</template>

<script>
export default {
	name: 'mainTable',
	props: {
		tableData: {
			type: Array
		},
		// totalCount: {
		// 	type: Number
		// },
		// size: {
		// 	type: Number,
		// 	default: 20
		// },
		// page: {
		// 	type: Number,
		// 	default: 1
		// },
		AuthorityList: {
			type: Object
		}
	},
	data () {
		return {
			tableHeight: '100%',
			// pagination: {
			// 	page: this.page,
			// 	size: this.size
			// },
			tableSelectUtils: this.$fxUtils.tableSelectUtils({
				key: 'returnid'
			})
		}
	},
	created () {
		// this.getAuthority('07_0001_0000_00')
	},
	computed: {
		ids () {
			return this.tableSelectUtils.getSelectRows()
		}
	},
	methods: {
		initIschoose () {
			this.tableSelectUtils.setTableDefaultSelect(this.tableData, this.$refs.table)
		},
		clear () {
			this.tableSelectUtils.clear()
		},
		sortChangeHandle (data) {
			if (data.order === null) {
				this.$emit('sortSearch', { orderKey: '', orderBy: '' })
			} else {
				let orderBy = data.order === 'descending' ? 'desc' : 'asc'
				this.$emit('sortSearch', { orderKey: data.prop, orderBy: orderBy })
			}
		},
		// handleSelectionChange (data) {
		// 	this.tableSelectUtils.selectToggle(this.tableData, data)
		// 	let value = this.tableSelectUtils.getSelectRows()
		// 	let ids = value.map(item => {
		// 		return item.returnid
		// 	})
		// 	this.$emit('selectIds', ids)
		// },
		// 跳订单
		goOrderDetail (row) {
			let orderParams = {}
			orderParams.orderId = row.orderid
			orderParams.statusId = row.statusId
			orderParams.differ = row.differ
			orderParams.buypullstate = row.buypullstate
			switch (row.orderStatus) {
			case 0:
				orderParams.billState = '待付款'
				break
			case 1:
				orderParams.billState = '待接单'
				break
			case 2:
				orderParams.billState = '待发货'
				break
			case 3:
				orderParams.billState = '待收货'
				break
			case 4:
				orderParams.billState = '已完成'
				break
			case 5:
				orderParams.billState = '已取消'
				break
			}
			window.sessionStorage.setItem('orderInfo', JSON.stringify(orderParams))
			let tabInfo = {}
			tabInfo.active = orderParams.billState
			tabInfo.isSellerpull = false
			tabInfo.orderStatus = row.orderStatus
			window.sessionStorage.setItem('tabInfo', JSON.stringify(tabInfo))
			this.$fxGoBlank('/blankdetail', this.$router)
		}
		// getDetail (value) {
		// 	window.sessionStorage.setItem('withdrawalReviewId', value.cashoutid)
		// 	this.$router.push(`/main/withdrawalReviewDetail`)
		// },
		// deleteItem (row) {
		// 	this.$confirm('提成规则删除后不可恢复，是否继续删除？', '提示', {
		// 		confirmButtonText: '确定',
		// 		cancelButtonText: '取消',
		// 		type: 'warning',
		// 		closeOnClickModal: false
		// 	}).then(() => {
		// 		let params = {
		// 			commissionPlanIds: row.planid
		// 		}
		// 		this.$store.dispatch('requestPost', {
		// 			url: `${this.$fxBaseApi.urlQIVShop}/commission/delplan`,
		// 			data: params
		// 		}).then(res => {
		// 			if (res.result) {
		// 				this.$message.success('删除成功')
		// 				this.$emit('modifySuc')
		// 			} else {
		// 				this.$message.error(res.msg)
		// 			}
		// 		}).catch(error => {
		// 			this.$message.error(error.msg)
		// 		})
		// 	}).catch(() => {})
		// },
		// handleSizeChange (value) {
		// 	this.pagination.size = value
		// 	this.$emit('handleSize', value)
		// },
		// handlePageChange (value) {
		// 	this.pagination.page = value
		// 	this.$emit('handlePage', value)
		// }
	}
}
</script>

<style lang="stylus" scoped>
.main-table {
	display flex
	flex: 1
	flex-direction: column
	min-height: 0
	.main-table-box {
		flex: 1
		width: 100%
		// padding-bottom 10px
		box-sizing: border-box;
		overflow: hidden
		overflow-y: auto;
		display flex
		flex-direction: column
		.under-num {
			cursor :pointer;
			color: var(--fx-primary-color);
			text-decoration: underline
			display: flex;
			align-items: center;
		}
	}
	.over-hidden{
		overflow: hidden;
		text-overflow:ellipsis;
		white-space: nowrap;
	}
}
</style>
<style lang="stylus">
.main-table {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
	.el-radio-group {
		display flex
		flex-direction: column
		padding: 0 15px 20px
		.el-radio {
			line-height: 30px
		}
	}
}
</style>
